<template>
  <v-dialog
    persistent
    :fullscreen="isMobileBreakpoint"
    v-model="openModal"
    width="65vw"
  >
    <v-card
      class="card-container"
      :class="{ 'no-padding': noDefaultPadding }"
      style="height: 100%"
    >
      <div>
        <v-toolbar
          elevation="0"
          color="background"
          class="fluid-toolbar"
          style="z-index: 999"
          :class="{
            small: smallToolbarPadding,
            'pb-4': !smallToolbarPadding,
          }"
        >
          <v-toolbar-title class="body-bold-medium">
            {{ $t('message.ai.mindmap.mindmap') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div v-if="!isMobileBreakpoint">
            <base-btn
              v-if="!isEditingMode"
              @click="isEditingMode = !isEditingMode"
              class="mr-3"
              type="tertiary"
            >
              <v-icon class="mr-1" size="16">panda-edit</v-icon>
              {{ $t('message.ai.abstract.edit') }}</base-btn
            >
            <base-btn
              @click="handleDownload"
              v-if="!isEditingMode"
              type="primary"
            >
              {{ $t('message.ai.abstract.downloadEbook') }}
              <v-icon size="16">panda-download</v-icon>
            </base-btn>

            <base-btn
              v-if="isEditingMode"
              @click="saveEditedMindmap"
              :loading="loadingSaveButton"
              >{{ $t('message.pages.video.publish') }}</base-btn
            >
          </div>
          <v-toolbar-items
            style="display: contents"
            class="align-self-baseline"
          >
            <v-btn icon @click="handleCloseModal" class="no-ripple pl-6">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-if="!isEditingMode" class="d-flex modalIcons">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-on="on"
                v-bind="attrs"
                @click="centralizeMindMap"
                class="modalIcon"
              >
                <img class="custom-svg" src="@/assets/centralizeIcon.svg"
              /></span>
            </template>
            <span>{{ $t('message.ai.mindmap.centralize') }} </span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-on="on"
                v-bind="attrs"
                @click="zoomOutMindMap"
                class="modalIcon"
                :class="{ 'disabled-icon': isZoomOutDisabled }"
                :disabled="isZoomOutDisabled"
              >
                <img class="custom-svg" src="@/assets/zoomOut.svg" />
              </span>
            </template>
            <span>{{ $t('message.ai.mindmap.reduce') }} </span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                @click="zoomInMindMap"
                v-on="on"
                v-bind="attrs"
                class="modalIcon"
                :class="{ 'disabled-icon': isZoomInDisabled }"
                :disabled="isZoomInDisabled"
              >
                <img class="custom-svg" src="@/assets/zoomIn.svg" />
              </span>
            </template>
            <span>{{ $t('message.ai.mindmap.amplify') }} </span>
          </v-tooltip>
        </div>
        <MindmapEditor v-if="isEditingMode" :videoId="videoId" />
        <div v-show="!isEditingMode" class="row-container">
          <div class="flexible-div display-mindmap">
            <div class="mindmap-scroll-container">
              <pre
                ref="mindmapContainer"
                v-if="!isEditingMode"
                :key="componentKey"
                id="mindmap-container1"
                class="mermaid"
              ></pre>
            </div>
          </div>
        </div>
      </div>
      <div class="mobileActions" v-if="isMobileBreakpoint">
        <base-btn
          v-if="!isEditingMode"
          @click="isEditingMode = !isEditingMode"
          class="mr-3"
          type="tertiary"
        >
          <v-icon class="mr-1" size="16">panda-edit</v-icon>
          {{ $t('message.ai.abstract.edit') }}</base-btn
        >
        <base-btn @click="handleDownload" v-if="!isEditingMode" type="primary">
          {{ $t('message.ai.abstract.downloadEbook') }}
          <v-icon size="16">panda-download</v-icon>
        </base-btn>

        <base-btn
          v-if="isEditingMode"
          @click="handleCloseModal"
          class="mr-3 px-6"
          type="tertiary"
          :loading="loadingSaveButton"
          >{{ $t('message.pages.video.cancel') }}</base-btn
        >

        <base-btn
          v-if="isEditingMode"
          @click="saveEditedMindmap"
          :loading="loadingSaveButton"
          class="px-6"
          >{{ $t('message.pages.video.publish') }}</base-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
//import BaseBtn from '@/components/BaseBtn.vue'
import MindmapEditor from '@/components/MindmapEditor.vue'
import Panzoom from 'panzoom'
import { mapActions, mapMutations, mapState } from 'vuex'
import Storage from '@/utils/Storage'
import i18n from '@/translations/lang'

export default {
  name: 'MindmapEditModal',
  components: {
    //BaseBtn,
    MindmapEditor,
  },
  data: () => ({
    openModal: false,
    mermaidScriptLoaded: false,
    mindmap: '',
    mermaid: '',
    mermaidDiagram: '',
    componentKey: 1,
    themeChanged: false,
    isZoomInDisabled: false,
    isZoomOutDisabled: false,
    loadingSaveButton: false,
    isEditingMode: false,
    dataLoaded: false,
  }),
  props: {
    noDefaultPadding: {
      type: Boolean,
      default: false,
    },
    smallToolbarPadding: {
      type: Boolean,
      default: false,
    },
    videoId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log('mounted')
    this.$root.$on('renderDiagram', async (myConvertedModel) => {
      this.mermaidScriptLoaded = false
      this.mindmap = myConvertedModel
      this.componentKey += 1
      await this.renderDiagram()
    })
    this.$root.$on('openEditMindMapModal', async () => {
      this.handleOpenModal()
      this.isEditingMode = true
      if (!this.dataLoaded) {
        await this.handleData()
        this.dataLoaded = true
      }
    })
    this.$root.$on('openMindMapModal', async () => {
      this.handleOpenModal()
      this.isEditingMode = false
      if (!this.dataLoaded) {
        await this.handleData()
        this.dataLoaded = true
      }
    })
    this.$root.$on('loadingSaveButton', (val) => {
      this.loadingSaveButton = val
      if (!val) {
        this.handleCloseModal()
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('openEditMindMapModal')
    this.$root.$off('loadingSaveButton')
  },
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    ...mapState({
      hasData: (state) => state.video.aiWorkFlow?.data,
      video: (state) => state.video.video,
    }),
    isDarkTheme() {
      return this.$vuetify.theme.dark
    },
  },
  watch: {
    isEditingMode(newVal) {
      if (!newVal) {
        // Saiu do modo de edição, renderize o Mermaid
        this.$nextTick(() => {
          this.clearMermaidContainer() // Limpa o container
          this.renderDiagram() // Renderiza o diagrama
        })
      }
    },
    isDarkTheme: {
      handler() {
        this.themeChanged = true
      },
    },
  },
  methods: {
    ...mapMutations('video', ['UPDATE_AI_VIDEO_CONFIG', 'UPDATE_VIDEO_CONFIG']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('video', ['handleFetchAiWorkFlowData']),
    handleDownload() {
      this.$root.$emit('handleDownloadMindMap')
    },
    clearMermaidContainer() {
      const mermaidContainer = document.getElementById('mindmap-container1')
      if (mermaidContainer) {
        mermaidContainer.innerHTML = '' // Limpa o conteúdo
        mermaidContainer.removeAttribute('data-processed') // Remove o atributo de processamento
      }
    },
    async handleData() {
      if (this.hasData) {
        const { mindmap } = this.hasData

        this.mindmap = mindmap
        await this.renderDiagram()
      } else {
        let { pullzone_name, video_external_id } = this.video
        try {
          const { mindmap } = await this.handleFetchAiWorkFlowData({
            pullzone_name,
            video_external_id,
          })

          this.mindmap = mindmap
          await this.renderDiagram()
        } catch (error) {
          console.error(error)
        }
      }
    },
    async loadMermaidScript() {
      return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src =
          'https://cdn.jsdelivr.net/npm/mermaid@10.6.1/dist/mermaid.min.js'

        script.onload = () => {
          this.mermaidScriptLoaded = true
          this.mermaid = window.mermaid

          resolve()
        }
        document.head.appendChild(script)
      })
    },
    addMindmapToLocalStorage(val) {
      const key = 'mindmapString'
      Storage.setItem(key, val)
    },
    async renderDiagram() {
      if (!this.mermaidScriptLoaded) {
        await this.loadMermaidScript()
      }

      if (this.mermaid) {
        this.mermaidDiagram = this.jsonToMermaid(this.mindmap)
        //console.log(this.mermaidDiagram)
        this.addMindmapToLocalStorage(JSON.stringify(this.mindmap))
        await this.$nextTick()
        const mermaidContainer = document.getElementById('mindmap-container1')
        if (mermaidContainer) {
          this.clearMermaidContainer()
          mermaidContainer.textContent = this.mermaidDiagram
          this.initializePanzoom()
          window.mermaid.initialize({
            startOnLoad: true,
            flowchart: {
              useMaxWidth: false,
              htmlLabels: true,
              curve: 'linear',
            },
          })
          window.mermaid.initialize()
          try {
            await window.mermaid.run({
              querySelector: '#mindmap-container1',
            })
          } catch (error) {
            console.log(error)
          }
        }
        //this.preventToggleQuickly = false
      }
    },
    jsonToMermaid(json) {
      let mermaidStr = `mindmap ${json.theme}\n`
      let nodeCount = 0

      function breakText(text, maxLineLength = 20) {
        return text.replace(
          new RegExp(`(.{1,${maxLineLength}})(\\s+|$)`, 'g'),
          '$1\n'
        )
      }

      function processNode(node, indent, isRoot = false) {
        let nodeId = `N${nodeCount++}`
        let nodeLabel = node.text ? node.text : `Node ${nodeId}`
        nodeLabel = breakText(nodeLabel)

        if (!isRoot) {
          mermaidStr += `${indent}${nodeId}("${nodeLabel}")\n`
        }

        if (node.children) {
          let childIndent = indent + '    '
          node.children.forEach((child) => {
            mermaidStr += `${indent}    ${nodeId} --> `
            processNode(child, childIndent)
          })
        }
      }

      processNode(json, '', true)
      return mermaidStr
    },

    centralizeMindMap() {
      const container = this.$refs.mindmapContainer
      if (container && this.panzoomInstance) {
        this.panzoomInstance.moveTo(0, 0)
      }
    },

    zoomOutMindMap() {
      const container = this.$refs.mindmapContainer

      if (container && this.panzoomInstance) {
        const currentScale = this.panzoomInstance.getTransform().scale
        this.isZoomInDisabled = false
        if (currentScale <= 0.5) {
          this.isZoomOutDisabled = true
          return
        }

        this.isZoomOutDisabled = false
        this.panzoomInstance.smoothZoom(
          container.offsetWidth / 2,
          container.offsetHeight / 2,
          0.8
        )
      }
    },

    recenterMindMap() {
      const container = this.$refs.mindmapContainer

      if (container && this.panzoomInstance) {
        const containerWidth = container.offsetWidth
        const containerHeight = container.offsetHeight
        const contentBounds = container.querySelector('svg')?.getBBox()

        if (contentBounds) {
          const contentWidth =
            contentBounds.width * this.panzoomInstance.getTransform().scale
          const contentHeight =
            contentBounds.height * this.panzoomInstance.getTransform().scale
          const centerX = (containerWidth - contentWidth) / 2
          const centerY = (containerHeight - contentHeight) / 2
          this.panzoomInstance.moveTo(centerX, centerY)
        }
      }
    },

    initializePanzoom() {
      const container = this.$refs.mindmapContainer
      if (container) {
        this.panzoomInstance = Panzoom(container, {
          zoomSpeed: 0.065,
          maxZoom: 10,
          minZoom: 0.5,
        })
      }
    },

    zoomInMindMap() {
      const container = this.$refs.mindmapContainer
      const currentScale = this.panzoomInstance.getTransform().scale
      console.log('Zoom In Scale:', currentScale)
      this.isZoomOutDisabled = false
      if (currentScale >= 10) {
        this.isZoomInDisabled = true
      } else {
        this.isZoomInDisabled = false
      }
      if (container && this.panzoomInstance && !this.isZoomInDisabled) {
        this.panzoomInstance.smoothZoom(
          container.offsetWidth / 2,
          container.offsetHeight / 2,
          1.2
        )
      }
    },
    handleOpenModal() {
      this.openModal = true
      if (this.themeChanged) {
        this.$root.$emit('updateDiagramTheme')
      }
      this.themeChanged = false
    },
    handleCloseModal() {
      this.openModal = false
    },
    saveEditedMindmap() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.ai.mindmap.mindmapStatus'),
        type: 'success',
      })
      this.$root.$emit('saveEditedMindmap')
    },
    handleDiscardChanges() {
      this.$root.$emit('handleDiscardChanges')
    },
  },
}
</script>

<!-- <style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style> -->

<style lang="scss" scoped>
// .not-allowed {
//   cursor: not-allowed !important;
// }
::v-deep #cont-ainer {
  border: none !important;
}
::v-deep .no-x-padding {
  .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
// .fluid-toolbar {
//   height: unset !important;
//   .v-toolbar__content {
//     height: unset !important;
//   }

//   &.small {
//     height: unset !important;
//   }
// }

::v-deep .fluid-toolbar:not(.small) .v-toolbar__content {
  padding: 16px 24px 0px 24px !important;
}

// .v-application .small-title.text-h6 {
//   font-size: 18px !important;
// }
</style>

<style lang="scss" scoped>
.modalIcons {
  position: absolute;
  top: 90px;
  right: 8px;
  z-index: 999;
}

.mobileActions {
  display: flex;
  justify-content: center;
  padding: 16px;
  background: varFigma(neutral-100-white);
  z-index: 999;
}

.modalIcon.disabled-icon {
  background: varFigma(neutral-95-lightest);
  cursor: not-allowed;
  pointer-events: none; /* Impede cliques em ícones desabilitados */
}

.bg-dark {
  .custom-svg {
    filter: brightness(0) saturate(100%) invert(81%) sepia(7%) saturate(280%)
      hue-rotate(193deg) brightness(93%) contrast(90%);
  }
}

.card-container {
  max-height: 90vh;
  > div {
    max-height: inherit;
  }
  // ::v-deep * {
  //   font-family: Rubik !important;
  // }
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .v-toolbar__content,
  .v-toolbar__items,
  .v-toolbar__items > button {
    height: unset !important;
    width: auto !important;
  }

  &:not(.no-padding) {
    padding: 0 !important;
  }
}
// .v-btn.no-ripple::before {
//   display: none;
// }
</style>

<style lang="scss" scoped>
#mermaid-container {
  display: flex;
  justify-self: center;
  align-items: baseline;
  width: auto;
  height: auto;
  width: 100%;
  height: 100%;
}

.modalIcon {
  align-content: center;
  justify-content: center;
  padding: 10px;
  margin-right: 8px;
  border-radius: var(--spacing-03, 8px);
  background: varFigma(neutral-100-white);
  cursor: pointer;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}

.modalIcon:hover {
  background: varFigma(neutral-95-lightest);
}

.mindmap-scroll-container {
  overflow: hidden;
  height: 600px;
  // width: 450px;
}

.row-container {
  background: #f9f9fb;
  border-top: 1px solid varFigma(neutral-95-lightest);
  display: flex;
  width: 100%;
  height: 600px;
}
.flexible-div {
  flex-grow: 1;
}

.loader-width {
  width: 100%;
}

.mindmap-scroll-container:active {
  cursor: grabbing;
}
</style>
